import { Modal } from './modal';

/**
* @param {object} o translation object
* @param {object} o.translations translations containing closeText, message and title
*/
export class UserMenuModal {
    constructor(o) {
        o = typeof o !== 'undefined' ? o : {};
        this.translations = o.translations;

        if (typeof this.translations.closeText === 'undefined') {
            throw 'UserMenuModal class called without property translations.closeText';
        }

        if (typeof this.translations.message === 'undefined') {
            throw 'UserMenuModal class called without property translations.message';
        }

        if (typeof this.translations.title === 'undefined') {
            throw 'UserMenuModal class called without property translations.title';
        }

        this.modal = new Modal();
        this.modal.closeText = this.translations.closeText;
        this.modal.message = this.translations.message;
        this.modal.title = this.translations.title;
    }

    showModal() {
        this.modal.show();
    }
}